
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { PleurisyScoreWithReportData } from '@/models/swine/report/report.model';
import { addDecimalPointToNumbers } from '@/utils/formats';
@Component({})
export default class PleurisyTable extends Vue {
  @Prop({
    type: Object,
    default: null,
  })
  currentReportDetails!: PleurisyScoreWithReportData;

  standardizeValue(data: number) {
    return addDecimalPointToNumbers(data);
  }
}
